import styled from 'styled-components';
const RecaptchaWrapper = styled.div `
  width: 100%;
`;
export default {
    RecaptchaWrapper,
};
